<p
  *ngIf="textCitation"
  class="chat-message-citation"
  [matTooltip]="citationTitle"
  target="_blank"
>
  {{ citationSourceUrl || citationTitle }}
</p>

<a
  *ngIf="!textCitation"
  class="chat-message-citation"
  rel="noopener"
  [href]="citationSourceUrl"
  target="_blank"
  [matTooltip]="citationSourceUrl"
  (click)="handleClick($event)"
>
  {{ citationTitle || citationSourceUrl }}
</a>
